import { palette } from '@livable/saas-react-components';
const MuiPaper = {
  styleOverrides: {
    root: {
      boxShadow: palette.shadows.light,
      backgroundColor: palette.shades[100],
      position: 'relative',
      zIndex: '10',
      '&.MuiMenu-paper': {
        boxShadow: palette.shadows.hard,
        marginTop: '10px'
      },
      '& + .MuiPaper-root': {
        marginTop: '20px'
      },
      '& + .Mui-error': {
        position: 'relative',
        '&:after': {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: "''",
          display: 'block',
          borderRadius: '2px',
          position: 'absolute',
          border: "2px solid ".concat(palette.error.main)
        },
        '& > div': {
          zIndex: 1,
          position: 'relative'
        }
      }
    }
  },
  variants: [{
    props: {
      variant: 'formWrapper'
    },
    style: {
      padding: '32px 40px 48px 40px',
      '+ .MuiButton-root': {
        marginTop: '32px'
      }
    }
  }, {
    props: {
      variant: 'evenWrapper'
    },
    style: {
      padding: '32px 40px',
      '+ .MuiButton-root': {
        marginTop: '32px'
      }
    }
  }, {
    props: {
      variant: 'smallWrapper'
    },
    style: {
      padding: '24px 32px'
    }
  }, {
    props: {
      variant: 'basic'
    },
    style: {
      padding: '24px 40px'
    }
  }, {
    props: {
      variant: 'evenBasic'
    },
    style: {
      padding: '32px'
    }
  }, {
    props: {
      variant: 'evenBasicSmall'
    },
    style: {
      padding: '24px'
    }
  }]
};
export default MuiPaper;